import React from 'react'
import '../styles/Brands.css'
import BrandGrid from '../components/brandLogos/BrandGrid'
import { Link } from 'react-router-dom'

const Brands = () => {

  return (
    <div className='minHeight100'>
      <div className='hero-section'>
        <h2 className='pagetitle'>BRAND PARTNERS</h2>
        <p className='intro-text' style={{padding: "0 2rem"}}>
          From luxury fashion to cutting-edge technology, wellness products to gourmet foods, 
          our diverse portfolio represents the best brands across every industry seeking authentic celebrity endorsement.
          Below features some of the amazing brands I've had the pleasure of working with — and I'm always excited to connect with new ones!
        </p>
      </div>

      <div className='brands-section'>
        <div className='section-container'>
          <BrandGrid />
        </div>
      </div>

      <div className='brands-section' style={{display: 'flex', alignItems: "center"}}>
        <Link
          style={{margin: "0 auto"}}
          className='about-cta-button btn-primary'
          to="/contact"
        >
          Get in touch
        </Link>
      </div>

    </div>
  )
}

export default Brands